<template>
    <div class="wrapper">
        <loading v-model:active="isLoading" loader="dots" />
        <div class="wrapper__inner">
            <base-header v-if="!hideLayout"/>

            <main class="main">
                <slot />
            </main>

            <footer-navigation v-if="!hideLayout"/>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import BaseHeader from '@/blocks/base-header/base-header'
import FooterNavigation from '@/blocks/footer-navigation/footer-navigation'
import { useRoute } from 'vue-router'
import { useStore } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'BaseLayout',

    components: {
        BaseHeader,
        FooterNavigation,
        Loading
    },

    setup() {
        const route = useRoute();
        const store = useStore();        
        
        return {
            hideLayout: computed(() => !!route.meta.hideLayout),
            isLoading: computed(() => store.getters.isLoading)
        }
    }
}
</script>

<style>

</style>
